import { connect, Dispatch } from 'react-redux';

import { Member, RoleAction } from '@wix/members-domain-ts';
import { BadgeListProps } from '@wix/members-badge-lib';

import forDevice from '../../hoc/for-device';
import withTranslate from '../../hoc/with-translate';
import { FFState } from '../../../ff/state';
import { getFFRolesActions } from '../../state/roles/selectors';
import { followOrUnfollow } from '../../state/members/actions';
import { isSocial, getIsMobile, getIsRtlLocale, isExperimentEnabled } from '../../state/site/selectors';
import { getMemberBadgesSettings } from '../../state/badges-definitions/selectors';
import { goToFFPage, goToMemberPage, onRoleAction } from '../../state/ff-page/actions';
import { getGlobalSettings, getComponentSettings } from '../../selectors/settings-selectors';
import {
  getCurrentMemberId,
  showAsBlocked,
  findMemberByUid,
  getViewedMemberBlocked,
} from '../../state/members/selectors';
import { FFBoxMobile } from '../../components/ff-box/ff-box-mobile';
import { FFBoxDesktop } from '../../components/ff-box/ff-box-desktop';
import { Experiments } from '../../constants/experiments';

export interface FFBoxProps {
  t: TranslationFunction;
  member: Member;
  memberId: string;
  position: string;
  isSocial: boolean;
  isMobile: boolean;
  pictureStyle: number;
  rolesActions: RoleAction[];
  showAsBlocked: boolean;
  isBlocked: boolean;
  showFollowers: boolean;
  badgesSettings: BadgeListProps;
  currentMemberUid: string;
  goToFFPage: (memberId: string, pageType: boolean) => void;
  onRoleAction: (memberId: string, role: RoleAction) => void;
  goToMemberPage: (uid: string) => void;
  followOrUnfollow: (uid: string) => void;
  isRtlLocale: boolean;
}

const mapStateToProps = (state: FFState, { memberId }: { memberId: string }) => {
  return {
    member: findMemberByUid(state, memberId),
    isSocial: isSocial(state),
    rolesActions: getFFRolesActions(state, memberId),
    pictureStyle: getComponentSettings(state).pictureStyle,
    showFollowers: getGlobalSettings(state).showFollowers,
    showAsBlocked: showAsBlocked(
      state,
      memberId,
      isExperimentEnabled(state, Experiments.HIDE_SUSPENDED_LABEL_FOR_NON_OWNERS_FF_BOX),
    ),
    isBlocked: getViewedMemberBlocked(
      state,
      memberId,
      isExperimentEnabled(state, Experiments.USE_VIEWED_MEMBER_BLOCKED),
    ),
    badgesSettings: getMemberBadgesSettings(state, memberId),
    currentMemberUid: getCurrentMemberId(state),
    isMobile: getIsMobile(state),
    isRtlLocale: getIsRtlLocale(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<FFState>) => ({
  followOrUnfollow: (uid: string) => dispatch(followOrUnfollow(uid)),
  goToMemberPage: (memberId: string) => dispatch(goToMemberPage(memberId)),
  onRoleAction: (memberId: string, role: RoleAction) => dispatch(onRoleAction(memberId, role)),
  goToFFPage: (memberId: string, pageType: boolean) => dispatch(goToFFPage(memberId, pageType)),
});

export const FFBox = connect(mapStateToProps, mapDispatchToProps)(withTranslate(forDevice(FFBoxMobile, FFBoxDesktop)));
